module.exports = __webpack_public_path__ + "img/SURVEY_MEMORYLOSS.a96112c4.png";